
export default  Object.freeze({
  dr_consulta_anual_subscrição_mensal: 135,
  dr_consulta_odonto_anual_subscrição_mensal: 136,
  dr_consulta_semestral_subscrição_mensal: 137,
})
